import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=32ecefd6&"
import script from "./LabelValue.vue?vue&type=script&lang=ts&"
export * from "./LabelValue.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/components/miscellaneous/label-value.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports